import { Component } from '@angular/core';

@Component({
  selector: 'app-p-analytics',
  templateUrl: './p-analytics.component.html',
  styleUrls: ['./p-analytics.component.scss']
})
export class PAnalyticsComponent {

}
